'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UITabs from 'UIComponents/nav/UITabs';
import UITab from 'UIComponents/nav/UITab';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
import { getHasAnyContainerOrDndAreaToAddModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getHasThemeSettings } from 'ContentEditorUI/redux/selectors/themeSelectors';
import { getHasDesignTabPermissions } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  isReadOnlyMode: getIsReadOnlyMode(state),
  hasAnyContainerOrDndAreaToAddModules: getHasAnyContainerOrDndAreaToAddModules(state),
  hasThemeSettings: getHasThemeSettings(state),
  hasDesignTabPermissions: getHasDesignTabPermissions(state)
});
class BaymaxSidebarTabsContainer extends Component {
  numberOfTabsShown() {
    const {
      showAddTab,
      showDesignTab
    } = this.props;
    let numberOfTabsShown = 3;
    if (!showAddTab) {
      numberOfTabsShown -= 1;
    }
    if (!showDesignTab) {
      numberOfTabsShown -= 1;
    }
    return numberOfTabsShown;
  }
  disableAddTab() {
    const {
      isReadOnlyMode,
      hasAnyContainerOrDndAreaToAddModules
    } = this.props;
    return isReadOnlyMode || !hasAnyContainerOrDndAreaToAddModules;
  }
  addTabTooltip() {
    const {
      isReadOnlyMode,
      hasAnyContainerOrDndAreaToAddModules
    } = this.props;
    if (!hasAnyContainerOrDndAreaToAddModules) {
      return {
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "sidebar.tabs.add.disabled.message"
        }),
        tooltipProps: {
          use: 'longform',
          headingText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sidebar.tabs.add.disabled.title"
          })
        }
      };
    } else if (isReadOnlyMode) {
      return {
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "sidebar.tabs.add.readOnly"
        }),
        tooltipProps: {
          use: 'longform',
          headingText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sidebar.tabs.add.disabled.title"
          })
        }
      };
    }
    return null;
  }
  disableDesignTab() {
    const {
      hasThemeSettings,
      hasDesignTabPermissions
    } = this.props;
    return !hasThemeSettings || !hasDesignTabPermissions;
  }
  addDesignTooltip() {
    const {
      hasThemeSettings,
      hasDesignTabPermissions
    } = this.props;
    if (!hasThemeSettings) {
      return {
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "sidebar.tabs.design.disabled.noTheme.message"
        }),
        tooltipProps: {
          use: 'longform',
          headingText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sidebar.tabs.design.disabled.noTheme.title"
          })
        }
      };
    } else if (!hasDesignTabPermissions) {
      return {
        tooltip: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "sidebar.tabs.design.disabled.noPermissions.message"
        }),
        tooltipProps: {
          use: 'longform',
          headingText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sidebar.tabs.design.disabled.noPermissions.title"
          })
        }
      };
    }
    return null;
  }
  render() {
    const {
      children,
      selected,
      onTabChange,
      showAddTab,
      showDesignTab,
      panelClassName
    } = this.props;
    const panelClasses = `${panelClassName} clean-line-styles`;
    const tabsClasses = classNames('clean-lines-styles', this.numberOfTabsShown() <= 1 && "on-dark without-tabs", this.numberOfTabsShown() > 1 && 'with-tabs');
    if (this.numberOfTabsShown() <= 1) {
      return /*#__PURE__*/_jsx("div", {
        id: "sidebar-tabs",
        className: tabsClasses,
        children: /*#__PURE__*/_jsx("div", {
          className: panelClasses,
          children: children
        })
      });
    }
    return /*#__PURE__*/_jsxs(UITabs, {
      id: "sidebar-tabs",
      className: tabsClasses,
      selected: selected,
      fill: true,
      onSelectedChange: evt => onTabChange(evt.target.value),
      use: "enclosed-shaded",
      panelClassName: panelClasses,
      listClassName: "sidebar-tab-list",
      hideBorders: "left",
      children: [showAddTab && /*#__PURE__*/_jsx(UITab, Object.assign({
        disabled: this.disableAddTab(),
        tooltipPlacement: "top right",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "sidebar.tabs.add.title"
        }),
        tabId: SIDEBAR_PANELS.addWidget
      }, this.addTabTooltip(), {
        children: children
      })), /*#__PURE__*/_jsx(UITab, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "sidebar.tabs.contents.title"
        }),
        tabId: SIDEBAR_PANELS.widgetList,
        children: children
      }), showDesignTab && /*#__PURE__*/_jsx(UITab, Object.assign({
        disabled: this.disableDesignTab(),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "sidebar.tabs.design.title"
        }),
        tabId: SIDEBAR_PANELS.design
      }, this.addDesignTooltip(), {
        children: children
      }))]
    });
  }
}
BaymaxSidebarTabsContainer.propTypes = {
  children: PropTypes.node,
  selected: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  showAddTab: PropTypes.bool.isRequired,
  showDesignTab: PropTypes.bool.isRequired,
  hasThemeSettings: PropTypes.bool.isRequired,
  hasDesignTabPermissions: PropTypes.bool.isRequired,
  isReadOnlyMode: PropTypes.bool.isRequired,
  hasAnyContainerOrDndAreaToAddModules: PropTypes.bool.isRequired,
  panelClassName: PropTypes.string.isRequired
};
BaymaxSidebarTabsContainer.defaultProps = {
  showAddTab: false,
  showDesignTab: false,
  panelClassName: 'p-all-5 sidebar-scrollable-tab-panel'
};
export default connect(mapStateToProps)(BaymaxSidebarTabsContainer);